import script from "./AddWorkHistoryModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddWorkHistoryModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddWorkHistoryModal.vue?vue&type=style&index=0&id=1f84fd38&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f84fd38"]])

export default __exports__